export default class LpTabs {
  
  constructor() {
    if (this.setVars()) {
      this.setEvents();
    }
  }
  
  setVars() {
    
    this.settings = {
      'init': 'data-lp-tab',
      'button': 'data-lp-tab-button',
      'view': 'data-lp-tab-view'
    };
    
    
    this.lpTabs = document.querySelectorAll(`[${this.settings.init}]`);
    if (!this.lpTabs) return;
    
    return true;
  }
  
  setEvents() {
    this.lpTabs.forEach(tab => {
      tab.querySelectorAll(`[${this.settings.button}]`).forEach(btn => {
        btn.addEventListener('click', (e) => {
          const current = e.target.getAttribute(this.settings.button);
          tab.querySelectorAll(`[${this.settings.button}]`).removeClass('active');
          e.target.addClass('active');
          tab.querySelectorAll(`[${this.settings.view}]`).removeClass('active');
          tab.querySelector(`[${this.settings.view}=${current}]`).addClass('active')
        })
      })
    })
  }
}
